export enum SessionStorageKeys {
  AccessToken = 'accessToken',
  SubmissionId = 'submissionId',
  RiskWarningId = 'riskWarningId',
  RiskAcceptanceId = 'riskAcceptanceId',
  AuthCode = 'authCode',
  CodeVerifier = 'codeVerifier',
  OrganisationId = 'organisationId',
}
